// extracted by mini-css-extract-plugin
export default {"cards":"rules_cards__PUx3S","intro":"rules_intro__9Gdrj","infoCard":"rules_infoCard__rSJKE","light":"rules_light__1zCe+","dark":"rules_dark__l4kBh","header":"rules_header__7Q-LX"};